// MIT License

// Copyright (c) React Training 2015-2019
// Copyright (c) Remix Software 2020-2022

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.


// Copyright 2018 kamijin_fanta <kamijin@live.jp>

// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

// ---
// Icons are taken from the other projects
// so please check each project licences accordingly.


// The MIT License (MIT)

// Copyright (c) 2014 Call-Em-All

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import React from 'react'
import { NavLink } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import companyLogo from '../images/prathamlogo.webp';
import { GiHamburgerMenu } from "react-icons/gi";
import { useEffect } from 'react';
import { useRef } from 'react';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import "./NavbarStyle.css";
const Navbar = () => {
  const [showMediaIcons, setShowMediaIcons] = useState(false);
  let menuRef = useRef();
  useEffect(() => {
    let handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setShowMediaIcons(false);
      }
    }
    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    }
  }

  );
  return (
    <>
      {/* <div className="container"> */}
      <div className="uppernav">
        <div className="uppernavleft">
          <div className="navcall">
            <div><CallOutlinedIcon></CallOutlinedIcon></div>
            <div><a href="tel: +91-992-034-1878">9920341878</a></div>
          </div>

          <div className="navemail">
            <div><MailOutlineIcon></MailOutlineIcon></div>
            <div><a href="mailto: contact@prathaminvestments.com" target="_blank" rel="noreferrer">contact@prathaminvestments.com</a></div>
          </div>
        </div>

        <div className="uppernavright">
          <a href="https://www.njindiaonline.in/cdesk/login.fin" target="_blank" rel="noreferrer">LOG IN</a>
        </div>


      </div>


      <div className="hero" ref={menuRef}>
        <div className="logo">
          <NavLink to="/"> <div><img src={companyLogo} alt="Logo Here" className='logo1' /></div></NavLink>
        </div>
        <div className={showMediaIcons ? "inmobileview itemlist" : "itemlist"}>
          {/* <div className="itemlist"> */}
          {/* <div> */}
          <ul className='List'>
            <NavLink to="/"
              style={({ isActive }) => ({
                color: isActive ? 'rgb(0, 175, 239)' : '#545e6f',
                textDecoration: 'none',
                fontWeight: '500',
                // background: isActive ? '#7600dc' : '#f0f0f0',
              })}
            ><li className='listItem' onClick={() => setShowMediaIcons(false)}>HOME </li> </NavLink>

            <NavLink to="/about"
              style={({ isActive }) => ({
                color: isActive ? 'rgb(0, 175, 239)' : '#545e6f',
                // background: isActive ? '#7600dc' : '#f0f0f0',
                textDecoration: 'none',
                fontWeight: '500',
              })}
            > <li className='listItem' onClick={() => setShowMediaIcons(false)}>ABOUT US</li></NavLink>

            <NavLink to="/services"
              style={({ isActive }) => ({
                color: isActive ? 'rgb(0, 175, 239)' : '#545e6f',
                // background: isActive ? '#7600dc' : '#f0f0f0',
                textDecoration: 'none',
                fontWeight: '500',
              })}
            > <li className='listItem' onClick={() => setShowMediaIcons(false)}>SERVICES</li></NavLink>

            <NavLink to="/gallery"
              style={({ isActive }) => ({
                color: isActive ? 'rgb(0, 175, 239)' : '#545e6f',
                // background: isActive ? '#7600dc' : '#f0f0f0',
                textDecoration: 'none',
                fontWeight: '500',
              })}
            > <li className='listItem' onClick={() => setShowMediaIcons(false)}>GALLERY</li></NavLink>



            <NavLink to="/testimonials"
              style={({ isActive }) => ({
                color: isActive ? 'rgb(0, 175, 239)' : '#545e6f',
                textDecoration: 'none',
                fontWeight: '500',
                // background: isActive ? '#7600dc' : '#f0f0f0',
              })}
            > <li className='listItem' onClick={() => setShowMediaIcons(false)}>TESTIMONIALS </li></NavLink>

            <NavLink to="calculators"
              style={({ isActive }) => ({
                color: isActive ? 'rgb(0, 175, 239)' : '#545e6f',
                // background: isActive ? '#7600dc' : '#f0f0f0',
                textDecoration: 'none',
                fontWeight: '500',
              })}
            > <li className='listItem' onClick={() => setShowMediaIcons(false)}>CALCULATORS</li></NavLink>



            {/* <a href="https://www.njindiaonline.in/cdesk/login.fin" target="_blank" rel="noreferrer"><li className='listItem login' onClick={() => setShowMediaIcons(false)}>LOG IN</li></a> */}


          </ul>
          {/* </div> */}
        </div>

        <div className="hamburger-menu" onClick={() => setShowMediaIcons(!showMediaIcons)}>
          <GiHamburgerMenu className='hamburgerlines' />
        </div>

      </div>


      <Outlet />
    </>
  )

}

export default Navbar
